// React Imports
import React, { useEffect, useState } from "react";

// Internationalization Import
import i18n from "i18next";

// Internal Imports
import { fetchWrapper } from "../../helpers/fetchwrapper";
import { baseUrl } from "../../helpers/constants";
import { IUserDocument } from "../../Models/IUserDocument";
import authService from "../api-authorization/AuthorizeService";
import { IAppUserDto } from "../../Models/IAppUserDto";
import MediathekDocumentFilter from "./MediathekDocumentFilter";
import { IMediathekDocumentFilterDto } from "../../Models/IMediathekDocumentFilterDto";
import MediathekResult from "./MediathekResult";
import AddMediathekDocumentDialog from "./AddMediathekDocumentDialog";
import queryString from "query-string";
import { StackShim } from "@fluentui/react-migration-v8-v9";
import { LibraryRegular } from "@fluentui/react-icons";
import { Button } from "@fluentui/react-components";
import Header from "../Layout/Header";

// Function
function Mediathek(props: any) {
  const value = queryString.parse(props?.location?.search);
  const shortId = value.id?.toString();
  const [filterVals, setFilterVals] = useState<
    IMediathekDocumentFilterDto | undefined
  >({
    textfilter: "",
    shortId: shortId ? shortId : "",
    sprachenGuids: [],
    dokumentGruppenGuids: [],
    artikelId: "",
  });

  const [documents, setDocuments] = useState<IUserDocument[]>([]);
  const [loadingDocs, setLoadingDocs] = useState<boolean>(false);
  const [isAddDocDialogOpen, setIsAddDocDialogOpen] = useState<boolean>(false);
  const [currentUser, setCurrentUser] = useState<IAppUserDto | undefined>(
    undefined
  );

  const [mediathekState, setMediathekState] = useState<number>(0); // 0 = wird geladen, 1 = Ohne Login, 2 = mit Login

  const getDocumentsWithAuth = (filterValues: IMediathekDocumentFilterDto) => {
    setLoadingDocs(true);
    fetchWrapper
      .postWithAuth(
        `${baseUrl}/api/mediathek/getdocumentswithauth`,
        filterValues
      )
      .then((data: IUserDocument[]) => {
        setDocuments(data);
        setFilterVals((prevState: any) => ({
          ...prevState,
          shortId: "",
        }));
      })
      .finally(() => {
        setLoadingDocs(false);
      });
  };

  const getDocuments = (filterValues: IMediathekDocumentFilterDto) => {
    setLoadingDocs(true);
    fetchWrapper
      .post(`${baseUrl}/api/mediathek/getdocuments`, filterValues)
      .then((data: IUserDocument[]) => {
        setDocuments(data);
        setFilterVals((prevState: any) => ({
          ...prevState,
          shortId: "",
        }));
      })
      .finally(() => {
        setLoadingDocs(false);
      });
  };

  const getCurrentUser = () => {
    authService.getUser().then((user) => {
      if (user) {
        fetchWrapper
          .getWithAuth(`${baseUrl}/api/account/getcurrentuser`)
          .then((result: IAppUserDto) => {
            setCurrentUser(result);
            setMediathekState(2);
          })
          .catch((error) => {});
      } else {
        setMediathekState(1);
      }
    });
  };

  useEffect(() => {
    if (currentUser && filterVals) {
      getDocumentsWithAuth(filterVals);
    }
  }, [currentUser]);

  useEffect(() => {
    if (mediathekState == 1 && filterVals) {
      getDocuments(filterVals);
    } else if (mediathekState == 2 && filterVals) {
      getDocumentsWithAuth(filterVals);
    }
  }, [mediathekState]);

  useEffect(() => {
    getCurrentUser();
  }, []);

  return (
    <>
      <AddMediathekDocumentDialog
        isDialogOpen={isAddDocDialogOpen}
        onDismiss={() => {
          setIsAddDocDialogOpen(false);
        }}
      />

      <Header
        HTMLElement={
          <StackShim horizontal verticalAlign="center">
            <Button
              icon={<LibraryRegular fontSize={24} color="#ff6600" />}
              size="large"
              appearance="subtle"
            >
              MEDIATHEK
            </Button>
          </StackShim>
        }
      />

      <MediathekDocumentFilter
        location={window.location}
        isLuebUser={
          currentUser != undefined && currentUser.email.includes("luebbering")
        }
        onFilterValuesChanged={(filterVals: IMediathekDocumentFilterDto) => {
          // Filterwerte von Filter Komponente nur überschreiben wenn kein Shortlink vorhanden!

          setFilterVals(filterVals);
        }}
        onSearch={() => {
          if (currentUser && filterVals) {
            getDocumentsWithAuth(filterVals);
          } else if (filterVals) {
            getDocuments(filterVals);
          }
        }}
        onAddDocumentClicked={() => setIsAddDocDialogOpen(true)}
      />
      <MediathekResult
        documents={documents}
        isLoading={loadingDocs || mediathekState == 0}
        onReloadRequested={() => {
          if (currentUser && filterVals) {
            getDocumentsWithAuth(filterVals);
          } else if (filterVals) {
            getDocuments(filterVals);
          }
        }}
        isAuthenticated={currentUser != undefined}
      />
    </>
  );
}

// Export Function
export default Mediathek;
